<template>
  <div
    @click="e => this.$emit('click', e)"
    class="app-placeholder"
    :class="{
      'no-padding': noPadding,
    }"
  >
    <app-image
      v-if="image"
      :src="image"
      class="app-placeholder-image"
      contain
    />

    <h1 v-if="title" v-html="title" class="app-placeholder-title"></h1>

    <div v-if="$slots.default" class="app-placeholder-content">
      <slot />
    </div>

    <p
      v-else-if="description"
      v-html="description"
      class="app-placeholder-content"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'AppPlaceholder',

  props: {
    image: {
      type: String,
    },

    title: {
      type: String,
    },

    description: {
      type: String,
    },

    noPadding: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-placeholder {
  margin: auto;
  padding: $defaultPadding;
  text-align: center;

  &.no-padding {
    padding: 0;
  }

  > .app-placeholder-image {
    margin: 0 auto 1rem;
    max-height: 25vh;
  }

  > .app-placeholder-content {
    margin-top: 0;
    color: #808080;
  }
}
</style>
